module.exports = "/_next/static/images/ic_tshirt-e6b7e91036251276ec8a0be775742712.png";